/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';

import withJsonLd from '@nerdwallet/json-ld';
import { getArticleSchema } from '@nerdwallet/json-ld/mappings/wp/article';
import { getNerdlayoutDynamicOptions } from '@nerdwallet/wp-api/utils/meta-data';

import GlobalMarkupOptions from '@nerdwallet/nw-app-module/GlobalMarkupOptions';

import {
  getArticleTypeConfig,
  getArticleCanonicalUrl,
} from '~/lib/article-utils';
import { appendEmbedJsScriptToDocument, renderEmbeds } from '~/lib/embed';
import { getActiveExperiments } from '~/lib/ab';
import { graphqlArticle as graphqlArticlePropType } from '~/lib/propTypes';

import WpEditLink from '../../components/wp-edit-link/wp-edit-link';
import Breadcrumb from './breadcrumb';

// pull in SEO experimental schema
@withJsonLd(({ graphqlArticle }) => graphqlArticle?.seo?.extraJsonLd)
@withJsonLd(({ graphqlArticle }) => getArticleSchema(graphqlArticle))
class ArticleContainer extends Component {
  componentDidMount() {
    // Manually append embed.js since embed <script> tags in the WP
    // API response aren't parsed via dangerouslySetInnerHTML.
    appendEmbedJsScriptToDocument();
  }

  componentDidUpdate() {
    // Rerender embeds if the article is updated and fully loaded.
    if (!this.props.loading) {
      renderEmbeds();
    }
  }

  renderNlOpts() {
    const {
      graphqlArticle,
      location: { pathname },
    } = this.props;

    const canonicalURL = getArticleCanonicalUrl(graphqlArticle, pathname);
    const { contentClusters } = graphqlArticle;

    const optionsOverrides = {
      canonicalURL,
      contentClusters,
    };

    const dynamicOpts = getNerdlayoutDynamicOptions({
      post: graphqlArticle,
      optionsOverrides,
    });

    const globalNavOpts = {
      globalNavProps: {
        primaryNavCategory: 'Our Top Picks',
      },
    };

    const opts = _.merge(globalNavOpts, dynamicOpts);

    return (
      <React.Fragment>
        <Breadcrumb>{graphqlArticle}</Breadcrumb>
        <GlobalMarkupOptions>{opts}</GlobalMarkupOptions>
      </React.Fragment>
    );
  }

  renderArticleComponent() {
    const articleTypeConfig = getArticleTypeConfig(
      this.props.graphqlArticle?.articleType
    );
    const ArticleComponent = articleTypeConfig.component;

    const props = {
      slug: this.props.slug,
      socialMediaLinkChannels: ['twitter', 'facebook', 'linked-in'],
      graphqlArticle: this.props.graphqlArticle,
      loading: this.props.loading,
      activeExperiments: getActiveExperiments({
        experiments: this.props.experiments,
        location: this.props.location,
        articleType: this.props.graphqlArticle?.articleType,
      }),
    };

    _.assign(props, _.omit(articleTypeConfig, ['component']));

    return <ArticleComponent {...props} />;
  }

  render() {
    return (
      <div className="article-container">
        {this.renderNlOpts()}
        {this.props.hasWpCookie && (
          <WpEditLink id={this.props.graphqlArticle.id} />
        )}
        {this.renderArticleComponent()}
      </div>
    );
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ArticleContainer.displayName = 'ArticleContainer';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ArticleContainer.propTypes = {
  graphqlArticle: graphqlArticlePropType,
  hasWpCookie: PropTypes.bool,
  loading: PropTypes.bool,
  slug: PropTypes.string.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  experiments: PropTypes.object,
};

// Ensure we only grab pieces of the state that we need.
const mapStateToProps = (state) =>
  _.pick(state, ['hasWpCookie', 'experiments']);
export default withRouter(connect(mapStateToProps)(ArticleContainer));
